import { SliderModels } from '@/types/slider'
import PptPage from '../PptPage/PptPage'
import { commonUtils } from '@/helpers/commonUtils'
import { useEffect, useRef, useState } from 'react'
import styles from './PptPage3.module.less'
import { useTranslation } from 'react-i18next'

interface Props {
  project: ProjectModels.ProjectDetail
  no: number
  onSliderReady: (slider: SliderModels.Slider, no: number) => void
}

function PptPage3({ no, onSliderReady }: Props) {
  const { t } = useTranslation()
  const [basicSlider, setBasicSlider] = useState<SliderModels.Slider>()
  const [elements, setElements] = useState<SliderModels.PPTElement[]>([])
  // const [pageHeaderElements, setPageHeaderElements] = useState<SliderModels.PPTElement[]>([])
  const [pageRect, setPageRect] = useState<DOMRect>()
  const cntTitleRef = useRef<HTMLImageElement>(null)
  const circleRef = useRef<HTMLImageElement>(null)
  const descRef = useRef<HTMLDivElement>(null)

  const onPageRender = (slider: SliderModels.Slider, pageRect: DOMRect) => {
    setBasicSlider(slider)
    setPageRect(pageRect)
  }

  useEffect(() => {
    if (!cntTitleRef.current || !circleRef.current || !descRef.current) {
      return
    }
    const cntTitleRect = cntTitleRef.current.getBoundingClientRect()
    const circleRect = circleRef.current.getBoundingClientRect()
    const descRect = descRef.current.getBoundingClientRect()

    const elements: SliderModels.PPTElement[] = [
      {
        type: 'image',
        src: circleRef.current.src,
        x: circleRect.x,
        y: circleRect.y,
        width: circleRect.width,
        height: circleRect.height,
      },
      {
        type: 'image',
        src: cntTitleRef.current.src,
        x: cntTitleRect.x,
        y: cntTitleRect.y,
        width: cntTitleRect.width,
        height: cntTitleRect.height,
      },
      {
        type: 'text',
        content: descRef.current.outerHTML,
        x: descRect.x,
        y: descRect.y - 50,
        width: descRect.width,
        height: descRect.height,
      },
  ]
    setElements(elements)
  }, [])

  useEffect(() => {
    if (!pageRect || !basicSlider || elements.length === 0) {
      return
    }
    const _elements = elements.map((element) => {
      const { x, y } = element
      return {
        ...element,
        x: x - pageRect.left,
        y: y - pageRect.top,
      }
    })
    const slider: SliderModels.Slider = {
      ...basicSlider,
      elements: [...basicSlider.elements, ..._elements],
    }
    onSliderReady(slider, no)
  }, [pageRect, basicSlider, elements])

  return (
    <PptPage
      no={no}
      bgSrc={commonUtils.getImagePath('PPTDownload/bg-3.jpg')}
      onPageRender={onPageRender}
    >
      <div className={styles.pptPage3}>
        <img
          ref={cntTitleRef}
          style={{ width: 200, height: 200 }}
          className={styles.cntTitle}
          src={commonUtils.getImagePath('PDFDownload/01.png')}
          alt=''
        />
        <img
          ref={circleRef}
          style={{ width: 102, height: 102 }}
          className={styles.circle}
          src={commonUtils.getImagePath('PDFDownload/pdf-page-3/page3-icon.png')}
        />
        <div className={styles.desc}>
          <span
            ref={descRef}
            style={{
              fontSize: 100,
              fontWeight: 'bold',
              color: '#2a2c3f',
              lineHeight: '120px',
            }}
          >
            {t('dashboard.projectDetailPage.basicInformation')}
          </span>
        </div>
      </div>
    </PptPage>
  )
}

export default PptPage3
